<template>
  <div
    class="flex flex-col w-auto xl:w-[calc(100%-40%)] min-h-auto xl:min-h-[100vh] relative pt-[100px] xl:pt-[10%] pb-[160px] xl:pb-[calc(10%+160px)] px-4 xl:px-4"
  >
    <!-- Content -->
    <div class="flex flex-col w-fit justify-center mx-auto">
      <station-address-form
        @form-submitted="resetSelectedStation"
        @stations-found="handleSearchStations"
      />
      <p class="text-grays-900 text-lg font-bold mb-[20px] mt-[33px]">
        מצאנו {{ stations.length }} תחנות באזור, תבחרו את התחנה שלכם.
      </p>
      <div class="w-fit pl-[10px]">
        <div
          class="flex-wrap gap-[27px] grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 xl:min-w-[679px] min-[1700px]:grid-w-[1002px] min-[1700px]:grid-cols-3 min-[1700px]:gap-[12px]"
        >
          <!-- Stations -->
          {{ !stations.length ? "טוען נתונים..." : "" }}
          <station
            v-for="station in stations"
            :key="station.id"
            :selectedStation="selectedStation"
            :station="station"
            @station-selected="handleStationSelection"
          >
          </station>
        </div>
      </div>
    </div>
    <!-- Action -->
    <section
      class="fixed bottom-0 w-[100%] xl:w-[calc(100%-40%)] flex flex-row justify-end items-center bg-grays-200 pt-[20px] xl:pt-[30px] pb-[20px] xl:pb-[60px] pl-[40%] xl:pl-[85px]"
    >
      <button-primary :disabled="!selectedStation" @click="handleNext">
        ממשיכים
      </button-primary>
    </section>
  </div>
</template>

<script>
import axiosInstance from "../../helpers/axios.js";
import { mapGetters } from "vuex";
import StationAddressForm from "@/components/Global/StationAddressForm.vue";
import Station from "@/components/Global/Station.vue";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";

export default {
  name: "find-station-step-2",
  components: { ButtonPrimary, Station, StationAddressForm },
  data() {
    return {
      selectedStation: null,
    };
  },
  methods: {
    async handleSearchStations({ lng, lat }) {
      try {
        const res = await axiosInstance.get(
          `/get_sites_by_distance/${lng}/${lat}`
        );
        this.$store.dispatch("findStation/updateStations", res.data);
      } catch (e) {
        console.error("Error fetching stations:", e);
      }
    },
    handleStationSelection(stationID) {
      this.selectedStation = stationID;
    },
    async handleNext() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (Object.keys(user).length === 0) {
        return;
      }
      const formData = {
        siteID: this.selectedStation,
      };
      try {
        localStorage.setItem("token", this.token);
        await axiosInstance.put("/clients", formData);
        localStorage.removeItem("token");
        user.siteID = this.selectedStation;
        localStorage.setItem("user", JSON.stringify(user));
      } catch (error) {
      } finally {
        this.resetSelectedStation();
        this.$emit("station-updated");
      }
    },
    resetSelectedStation() {
      this.selectedStation = null;
    },
  },
  computed: {
    ...mapGetters({
      token: "user/getToken",
    }),
    stations() {
      return this.$store.state.findStation.stations;
    },
  },
};
</script>

<style>
</style>